import { render } from "./ChatbotHomePage.vue?vue&type=template&id=25452125&scoped=true"
import script from "./ChatbotHomePage.vue?vue&type=script&lang=js"
export * from "./ChatbotHomePage.vue?vue&type=script&lang=js"

import "./ChatbotHomePage.vue?vue&type=style&index=0&id=25452125&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25452125"]])

export default __exports__